import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { addEvent, removeEvent } from '../../utils/dom';
import s from './Overlay.scss';

const Overlay = ({ variantClasses = [], children, isShowing, closeOverlayHandler = () => {} }) => {
	let classes = [s.overlay];
	if (variantClasses) classes = [...classes, ...(Array.isArray(variantClasses) ? variantClasses.filter((c) => !!c).map((c) => s[c]) : [s[variantClasses.toString()]])];
	if (isShowing) classes = [...classes, s.overlay__open];

	useEffect(() => {
		addEvent(document.getElementById('root'), 'click.closeOverlay', (e) => {
			if (isShowing && !e.target.closest('.js_overlay')) {
				e.preventDefault();
				e.stopPropagation();
				closeOverlayHandler(e);
			}
		});

		return () => {
			removeEvent(document.getElementById('root'), 'click.closeOverlay');
		};
	});

	return (
		<div className={classes.join(' ')}>
			<div className={s.overlay_closeBackground} onClick={closeOverlayHandler} onKeyPress={closeOverlayHandler} role="button" tabIndex="0" aria-labelledby="Close overlay" />
			<div className={[s.overlay_panel, 'js_overlay'].join(' ')}>
				<a className={s.overlay_panel_close} href="#close-overlay" onClick={closeOverlayHandler}>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M13 1L1 13" stroke="black" />
						<path d="M1 1L13 13" stroke="black" />
					</svg>
				</a>
				<div className={s.overlay_panel_inner}>
					{ children }
				</div>
			</div>
		</div>
	);
};

export default hot(module)(Overlay);
